import fetch from 'isomorphic-fetch';
import Config from '../../config/';

const API = {
  data: {
    async handleGetAllCategories(obj) {
      const response = await fetch(`/api/accountTagCategories/${JSON.stringify(obj)}`, {
        method: 'GET'
      });
      const status = response.status;
      const data = await response.json();
      return { data: data, status: status };
    },
    async handleGetAllTagsByCategory(obj) {
      const response = await fetch(`/api/accountTagTagsByCategory/${JSON.stringify(obj)}`, {
        method: 'GET'
      });
      const status = response.status;
      const data = await response.json();
      return { data: data, status: status };
    },
    async handleSaveTagsChanges(obj) {
      let response = await fetch(
        `${Config.api}/api/accountTagSaveTagsChanges`, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Pragma: 'no-cache'
        }),
        body: JSON.stringify(obj)
      });

      const status = response.status;
      let data = await response.json();
      return { data: data, status: status };
    }
  }
};
export default API;



// WEBPACK FOOTER //
// ./source/client/actions/account_tag/api/index.js